import $ from 'jquery';
import _ from 'ext:lodash';
import mapApi from 'vendor/google-maps-api';
import config from './config.js';
import LocateAClub from './LocateAClub';
import Framework from 'framework';
import constants from 'lib/constants';
import Omnibox from 'components/Omnibox';
import UrlUtils from 'lib/url-utils';
import MobileUtils from 'lib/mobile-utils';
import SessionStorage from 'lib/session-storage';
import Cookies from 'cookies-js';

$(() => {
	var mount = $(config.main);
	var locateAClub;

	// set directionsURL to be passed into locate a club object
	config.directionsURL = MobileUtils.getDirectionsBaseUrl();

	if(mount.length) {
		/* eslint-disable func-style */
		let resizeHandler,
			$window = $(Framework.global),
			$mapTab = $(config.mapTab),
			$map = $(config.map),
			handleTabClick,
			currentMap,
			lastBP = $window.width();

		let handleResize = () => {
			$window[0].setTimeout(resizeHandler, 0);
		};

		handleTabClick = () => {
			$window.trigger('resize');
		};

		// get member referral information
		let referralCode = '';
		let referralSource = '';
		const storedReferralInfo = Cookies.get(constants.memberReferralCookieName);
		if(storedReferralInfo !== null && typeof storedReferralInfo !== 'undefined' && storedReferralInfo.length > 0) {
			referralCode = storedReferralInfo.split('|')[0];
			referralSource = storedReferralInfo.split('|')[1];
		}

		// gather promotion information
		let promotionName = '';
		const promotionURLParam = UrlUtils.getUrlParameter(constants.promotionURLParam);
		const storedPromotionInfo = Cookies.get(constants.cookieCorpMembership);

		if(promotionURLParam !== null) {
			promotionName = promotionURLParam;
			SessionStorage.set(constants.cookieCorpMembership, promotionName + '|' + 'LTA-YTT', {domain: '.lifetime.life', expires: 0});
		} else if(storedPromotionInfo !== null && typeof storedPromotionInfo !== 'undefined' && storedPromotionInfo.length > 0) {
			promotionName = storedPromotionInfo.split('|')[0];
		}

		// get utm data
		const utmData = SessionStorage.get('utm_params');

		let altExp = false;

		if($('.club-locate.ae').length) {
			altExp = true;
		}

		let defaultProperties = JSON.parse($('#locate-a-club-default-properties').html());

		let authoredProperties = JSON.parse($('#locate-a-club-properties').html());

		mapApi.initialize().then(()=> {
			locateAClub = new LocateAClub(mount[0], config, Omnibox, referralCode, referralSource, promotionName, utmData, altExp, defaultProperties, authoredProperties);
			mapApi.createMap($map[0], referralCode, referralSource, promotionName, utmData, altExp, defaultProperties, authoredProperties).then((map) => {
				currentMap = map;
				resizeHandler = map.triggerResize.bind(map);

				const initialQuery = UrlUtils.queryStringParser('query');
				if(initialQuery) {
					Framework.actions.searchForNearestClub(initialQuery, config.queryLimit,	config.initialQueryDistance,
						constants.clubSearchSource.omniboxBlueBanner);
				}
				locateAClub.initialize(initialQuery, map);

				$window.on('resize', handleResize);
				$mapTab.on('click', handleTabClick);
			});
		});
	}

});
